import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Injectable, inject } from '@angular/core'; 
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { Auth } from 'aws-amplify';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';

@Injectable({
  providedIn: 'root'
})
class PermissionsService {

  constructor(private router: Router, private uievent:UieventhubService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

      //console.log('user',user);
      if(
        SessionHelper.getCustomer() && 
        state.url != '/customerportal' && 
        state.url != '/customerlight' && 
        state.url.substring(0,16) != '/portal/project/' &&
        state.url.substring(0,12) != '/useraccount'
      ){
        SessionHelper.clearViewAsCustomer();
        this.uievent.setViewAsCustomer(null);
        this.router.navigate(['/customerportal'], { queryParams: { returnUrl: state.url }});
        return true;
      }


    if(
      SessionHelper.getUserSub() != "" && 
      SessionHelper.getUserSub() != undefined && 
      SessionHelper.getChoosenOrg() != "" &&
      SessionHelper.getChoosenOrg() != undefined){
      //console.log('Guard state true',state);
      return true;
    }else{
      //console.log('Guard state',state)
      this.router.navigate(['/login'],{ queryParams: { returnUrl: state.url }});
      return false;
    }
  }
  }


export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(PermissionsService).canActivate(next, state);
}
